export const DEFAULT_NUMBER_OF_LOADED_ITEMS = 20;
